import { FaArchive } from "react-icons/fa";
import { ArchiveViewMain } from "../Components/ArchiveViewMain";

export const ArchiveModule = (DATA_USER_AUTH = null) => {

    return [
        {
            views: "PRIVATE", path: "/archive", component: <ArchiveViewMain />,
            roles: null, permissions: null, label: "Archivados", icon: <FaArchive />,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: false
        },

    ]
};
